import request from "@/utils/request";

export default function agentTransferDevice(params) {
  return request({
    url: `/device/device/agentTransferDevice`,
    method: "get",
    params,
  });
}
